import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import img1 from "../../src/images/service/one.png";
// import img3 from "../../src/images/service/three.png";
// import img2 from "../../src/images/service/two.png";

// const services = [
//   {
//     id: 1,
//     title: "Car Inspection",
//     image: img1,
//     accordionItems: [
//       {
//         title: "Pre Delivery Inspection",
//         description: "Detailed explanation of Pre Delivery Inspections.",
//       },
//       {
//         title: "Used Car Inspection",
//         description: "Detailed explanation of Service Title 2.",
//       },
//       {
//         title: "Pre - Trip Inspection",
//         description: "",
//       },
//     ],
//     navigate: "/service"
//   },
//   {
//     id: 2,
//     title: "Mentor Assistance",
//     image: img2,
//     description:
//       "Are you a Licensed Driver but afraid to take your car out on the roads?",
//     navigate: "/contact",
//     type: "mentor assistance"  
//   },
//   {
//     id: 3,
//     title: "Driver Assistance",
//     image: img3,
//     description:
//       "Medical Emergencies or going out with friends for drinks, need someone to drive you safely? We've got you covered.",
//     navigate: "/contact",
//     type: "driver assistance",  
//   },
// ];

const ServiceContent = ({ services }) => {
  const navigate = useNavigate();
  const [openAccordion, setOpenAccordion] = useState(null);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const handleRedirect = (inspectionType) => {
    if (!isAuthenticated) {
      navigate('/login');
    } else {
      navigate(`/service?inspectionType=${encodeURIComponent(inspectionType)}`);
    }
  };

  const handleServiceClick = (path, type) => {
    if (!isAuthenticated) {
      navigate('/login');
    } else {
      if (type) {
        navigate(`${path}?type=${encodeURIComponent(type)}`);
      } else {
        navigate(path);
      }
    }
  };

  if (!Array.isArray(services)) {
    return <div className="text-white text-center py-10">No services available.</div>;
  }

  console.log("Services:", services);

  return (
    <section className="w-full h-auto bg-banner pb-10 bg-contain">
      <div className="flex flex-wrap items-center justify-center w-full gap-0 sm:gap-0 md:gap-5">
        {services.map((service, idx) => (
          <div
            key={service.id || idx}
            className="relative group w-full sm:w-full md:w-[300px] h-auto cursor-pointer"
            data-aos="fade-up"
            data-aos-delay={idx * 100}
            onClick={() => handleServiceClick(service?.link, service?.type)}
          >
            <img
              src={service.image?.url}
              alt={`service image ${service.title}`}
              className="w-full h-[300px] object-cover lg:h-full lg:object-contain"
              onError={(e) => (e.target.style.display = 'none')}
            />

            <div className="absolute bottom-5 left-0 w-full md:w-[300px] text-left p-4 transition-all duration-500 ease-in-out lg:group-hover:bottom-[50%] lg:group-hover:left-0 lg:group-hover:transform lg:group-hover:translate-y-1/2">
              <h3 className="text-2xl font-extrabold text-white">{service.title}</h3>

                {Array.isArray(service.accordionItems) &&
                service.accordionItems.some(item => item.title?.trim()) ? (
                  <div className="mt-2">
                    {service.accordionItems.map((item, index) => (
                      <div key={index}>
                        <div
                          className="flex justify-between items-center"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRedirect(item.title);
                          }}
                        >
                          <h4 className="font-semibold text-white mt-2 hover:text-[#FFBD6F]">
                            {item.title}
                          </h4>

                          {/* Only show toggle button if this item has description */}
                          {item.description?.trim() && (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleAccordion(index);
                              }}
                              className="text-white ml-2"
                            >
                              {openAccordion === index ? '-' : '+'}
                            </button>
                          )}
                        </div>

                        {/* Show description if toggle is open */}
                        {openAccordion === index && item.description?.trim() && (
                          <p className="text-sm text-white mt-2">{item.description}</p>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  service.description?.trim() && (
                    <div className="mt-2">
                      <p className="text-sm text-white mt-2 hover:text-[#FFBD6F]">
                        {service.description}
                      </p>
                    </div>
                  )
                )}

            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceContent;